import ctl from '@netlify/classnames-template-literals';

export const rowContainerStyle = ctl(`
  flex 
  flex-col
`);

export const rowsContainerStyle = ctl(`
  w-full
  flex 
  flex-col
  justify-between
  gap-4
  mt-4
`);
